import { useLayoutEffect, useRef } from 'react';
import { springs } from './engine';
import { transition, currentState } from './effects';

// Animates items of a list to their new places when the order changes (e.g. a chat moving to
// the top), and lets new items spring in. Items need data-flip-key; the container must be their
// offsetParent (position: relative). Positions are layout positions, so scrolling doesn't matter.
export function useFlip(containerRef, deps, { config = springs.smooth, enter = { scale: 0.96, opacity: 0 } } = {}) {
  const prev = useRef(null); // key -> offsetTop

  useLayoutEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const items = [...container.querySelectorAll('[data-flip-key]')];
    const now = new Map(items.map(el => [el.dataset.flipKey, el.offsetTop]));
    const before = prev.current;
    prev.current = now;
    if (!before || !before.size) return; // first render or first load: no animation

    for (const el of items) {
      const key = el.dataset.flipKey;
      if (before.has(key)) {
        // Where it was on screen (including a move still in progress) relative to where it is now
        const dy = before.get(key) - now.get(key) + (currentState(el).y || 0);
        if (Math.abs(dy) > 1) transition([{ el, from: { y: dy } }], { config });
      } else {
        transition([{ el, from: enter, origin: 'top center' }], { config: springs.bouncy });
      }
    }
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
}
